import { Component, Input } from '@angular/core';
import { SignupService } from '../../../service/signup.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-form-navigation-buttons',
  templateUrl: './form-navigation-buttons.component.html',
  styleUrls: ['./form-navigation-buttons.component.scss']
})
export class FormNavigationButtonsComponent {

  @Input() isValid:boolean = false
  @Input() userProfile: any;
  @Input() form!:NgForm
  @Input() fireEvent:boolean = false

  constructor(private signup:SignupService){}

  async handleContinueClick(){
    if(this.fireEvent) {
      const event = new CustomEvent('formNavigationButton', { detail: { calledFrom: 'continue' } });
      window.dispatchEvent(event);
      return;
    }
    await this.signup.onContinue(this.userProfile)
  }

  handleBackClick():void{
    if(this.fireEvent) {
      const event = new CustomEvent('formNavigationButton', { detail: { calledFrom: 'back' } });
      window.dispatchEvent(event);
      return;
    }
    this.signup.onBack()
  }

  allFieldsValid({form}: NgForm){
    if(this.isValid) return true

    const { controls } = form;
    const keys = Object.keys(controls);
    if(keys?.length === 0) return false

    for(const key of keys){
      if(controls[key].errors) return false;
    }
    return true;
  }
}
